import React from 'react';
import * as ds from './dataService';
import { FormBaseLayout } from 'modules/components/layer10';

export type RemoveProjectFormProps = {
  id: string;
  handleClose: () => void;
};

export const FC = (props: RemoveProjectFormProps) => {
  const [
    fnRemoveProjectForm,
    { loading }
  ] = ds.useRemoveProject();
  // const form = ds.useFormState(props.id);
  const handleSubmit = async (id: string) => {

    await fnRemoveProjectForm(id);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={async () => {
        await handleSubmit(props.id);
      }}
      cancelButtonText='Cancel'
      successButtonText='Remove'
      isLoading={loading}
    >
      <>
      </>
    </FormBaseLayout.FC>

  );
};
